export default __webpack_public_path__ + "static/media/complementary--time-restrictions--g1.26eaeae5.png";